import { useEffect, useState } from "react";

export function useFeatureLayer() {

    //console.log('param', par)

    const [featureLayerCustom, setFeatureLayerCustom] = useState(null);

    //getViewSublayer
    const getViewSublayer = (mapView, mapLayer, sublayer) => {
        let out = null;
        let allSublayers = getViewMapLayer(mapView, mapLayer).allSublayers;
        for (let sl of allSublayers) {
            if (sl.id == sublayer.id) {
                out = sl;
            }
        }
        //console.log('getViewSublayer')
        return out;
    }

    //getViewMapLayer
    const getViewMapLayer = (mapView, mapLayer) => {
        let out = null;
        for (let layerView of mapView.layerViews) {
            if (layerView.layer.title == mapLayer.name) {
                out = layerView.layer;
            }
        }
        //console.log('getViewMapLayer')
        return out;
    }

    //createFeatureLayer
    const crearFeatureLayerCustom = async (mapView, mapLayer, sublayer) => {
        let layer = getViewSublayer(mapView, mapLayer, sublayer);
        //console.log('se ejecuta')
        return layer.createFeatureLayer()
    }

    return {
        featureLayerCustom,
        crearFeatureLayerCustom,
        setFeatureLayerCustom
    }
}
